import type {
  AppendLifecycleEventRequest,
  CreateProjectContactRequest,
  ProjectContactDto,
  ProjectLifecycleEventDto,
  ProjectLifecycleStatusDto,
  UpcomingBirthdayDto,
  UpdateProjectContactRequest,
} from '@ledokol/contracts'
import { api } from './client'

// ── Lifecycle ──
export async function fetchLifecycleStatus(projectId: string): Promise<ProjectLifecycleStatusDto> {
  const r = await api.get<ProjectLifecycleStatusDto>(`/projects/${projectId}/lifecycle`)
  return r.data
}

export async function appendLifecycleEvent(
  projectId: string,
  payload: AppendLifecycleEventRequest,
): Promise<ProjectLifecycleEventDto> {
  const r = await api.post<ProjectLifecycleEventDto>(`/projects/${projectId}/lifecycle`, payload)
  return r.data
}

// ── Contacts ──
export async function fetchContacts(projectId: string): Promise<ProjectContactDto[]> {
  const r = await api.get<ProjectContactDto[]>(`/projects/${projectId}/contacts`)
  return r.data
}

export async function createContact(
  projectId: string,
  payload: CreateProjectContactRequest,
): Promise<ProjectContactDto> {
  const r = await api.post<ProjectContactDto>(`/projects/${projectId}/contacts`, payload)
  return r.data
}

export async function updateContact(
  projectId: string,
  contactId: string,
  payload: UpdateProjectContactRequest,
): Promise<ProjectContactDto> {
  const r = await api.patch<ProjectContactDto>(`/projects/${projectId}/contacts/${contactId}`, payload)
  return r.data
}

export async function deleteContact(projectId: string, contactId: string): Promise<void> {
  await api.delete(`/projects/${projectId}/contacts/${contactId}`)
}

// ── Birthdays ──
export async function fetchUpcomingBirthdays(days = 30): Promise<UpcomingBirthdayDto[]> {
  const r = await api.get<UpcomingBirthdayDto[]>(`/birthdays/upcoming?days=${days}`)
  return r.data
}
